import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import es from './es.json';
import { DEFAULT_LANGUAGE, detectBrowserLanguage, isLanguageCode } from './languages';

const STORAGE_KEY = 'cobstream:language';

/** localStorage → browser language → default. DOM-safe. */
function initialLanguage(): string {
  if (typeof window !== 'undefined') {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (isLanguageCode(stored)) return stored;
    } catch {
      /* storage may be unavailable */
    }
  }
  return detectBrowserLanguage() ?? DEFAULT_LANGUAGE;
}

// A single shared instance. `initReactI18next` registers it as react-i18next's
// default, so `useTranslation()` picks it up without an <I18nextProvider>.
// Synchronous init (resources are inlined, no HTTP backend) + useSuspense:false
// so components never suspend on first paint or in tests.
void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: initialLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
  react: { useSuspense: false },
});

export default i18n;
export { STORAGE_KEY as LANGUAGE_STORAGE_KEY };
